import React, { useEffect, useState } from 'react'
import styles from './style/index.module.less'
import { Menu, Popover, Tooltip } from '@arco-design/web-react'
import {
  IconArrowLeft,
  IconBaseSync,
  IconBell,
  IconDatabase,
} from '@arco-iconbox/react-aidb-v2'
import IconFace1 from '../../assets/imgs/avatr.svg'
import BreadItem from '../BreadItem'
import { useSelector } from 'react-redux'
import { GlobalState } from '../../store'
import request from '@/utils/request'
import useStorage from '@/utils/useStorage'
import axios from 'axios'
import { getUserInfo } from '@/model/reference'
import { useHistory } from 'react-router-dom'
import UserAvatar from '@/assets/UserAvatar'
function Header(props) {
  const [arrowLeft, setArrowLeft] = useState('')
  const [_, setUserStatus] = useStorage('userStatus')
  const theme = useSelector((state: GlobalState) => state.theme)
  const history = useHistory()
  useEffect(() => {
    if (location.href.includes('userCenter')) {
      setArrowLeft('user')
    } else if (location.href.includes('intelligentDocument')) {
      if (location.search === '') {
        setArrowLeft('intelligentDocument-search')
      } else {
        setArrowLeft('intelligentDocument')
      }
    } else {
      setArrowLeft('')
    }
    if (
      localStorage.getItem('tabSwitch') == 'tree' &&
      location.pathname == '/intelligentDocument'
    ) {
      setArrowLeft('')
    }
  })
  //跳转个人中心
  function handleToUser() {
    history.push('/userCenter')
  }

  function onMenuItemClick(key) {
    event.preventDefault()
    const token = getCookie('access_token')

    if (key === 'logout') {
      setUserStatus('logout')
      axios
        .get(`/api-sso/login/loginOut?timestamp=${new Date().getTime()}`, {
          headers: {
            Cookie: `access_token=${document.cookie.replace(
              /(?:(?:^|.*;\s*)access_token\s*\=\s*([^;]*).*$)|^.*$/,
              '$1',
            )}`,
          },
        })
        .then((res) => {
          localStorage.removeItem('templateData')
          localStorage.removeItem('selectTem')
          document.cookie =
            'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
          history.push('/login')
        })
    } else if (key === 'account') {
      history.push('/userCenter?activeTab=account')
    } else if (key === 'admin-portal') {
      window.open(`https://admin.zgbjds.com/login?token=${token}`)
    } else if (key === 'admin-count') {
      window.open('https://analytics.zgbjds.com/ ')
    }
  }

  //下拉菜单渲染结构
  const btn3_content = (
    <div className={styles['btn-popover-list']}>
      <a
        href="/userCenter?activeTab=account"
        key="account"
        className={`${styles['item']} ${styles['itemBefor']}`}
        style={{ display: 'block' }}
        onClick={() => onMenuItemClick('account')}>
        个人中心
      </a>
      {localStorage.getItem('userName') == 'admin' && (
        <>
          <a
            key="go"
            className={styles['item']}
            style={{ display: 'block' }}
            onClick={() => onMenuItemClick('admin-portal')}>
            后台管理
          </a>
          <a
            key="go1"
            className={styles['item']}
            style={{ display: 'block' }}
            onClick={() => onMenuItemClick('admin-count')}>
            后台统计
          </a>
        </>
      )}
      <div
        key="logout"
        className={styles['item']}
        onClick={() => onMenuItemClick('logout')}>
        退出登录
      </div>
    </div>
  )

  //获取cookie

  // 获取cookie中的access_token
  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)',
      ),
    )
    return matches ? decodeURIComponent(matches[1]) : undefined
  }

  //跳转外站资料夹
  const handleGoDatabase = () => {
    event.preventDefault()
    window.open('https://cloud.zgbjds.com/s/KQLXJgqXTQBKnBn')
  }

  //返回首页
  const handleGoHome = () => {
    setArrowLeft('')
    history.push('/home')
  }
  return (
    <div className={`${styles['header']} ${styles[theme]}`}>
      {arrowLeft === 'user' ? (
        <div className={styles.back} onClick={handleGoHome}>
          <div className={styles.backIcon}>
            <IconArrowLeft />
          </div>
          <div className={styles.backText}>返回首页</div>
        </div>
      ) : (
        ''
      )}
      {arrowLeft === 'intelligentDocument' ? (
        <div className={styles.back}>
          {' '}
          <BreadItem></BreadItem>
        </div>
      ) : arrowLeft === 'intelligentDocument-search' ? (
        <div className={styles.back} style={{ display: 'none' }}>
          {' '}
          <BreadItem></BreadItem>
        </div>
      ) : (
        ''
      )}
      {/*同步更新*/}
      <div className={styles['headerRight']}>
        <Tooltip
          className={'custom-tooltip'}
          position="bottom"
          trigger="hover"
          content="同步更新">
          <div className={styles['icon']} onClick={() => location.reload()}>
            <IconBaseSync />
          </div>
        </Tooltip>
        <Tooltip
          className={'custom-tooltip'}
          position="bottom"
          trigger="hover"
          content="共享资料库">
          <a
            href="https://cloud.zgbjds.com/s/KQLXJgqXTQBKnBn"
            className={styles['header-database']}
            onClick={handleGoDatabase}>
            <IconDatabase />
          </a>
        </Tooltip>

        <Popover
          className={styles[theme == 'dark' ? 'headPover' : '']}
          position="bottom"
          content={btn3_content}>
          <div className={styles['user']}>
            <a
              href="/userCenter?activeTab=account" // 链接地址
              className={styles['user']}
              onClick={() => onMenuItemClick('account')}>
              <div className={styles['face']}>
                <UserAvatar
                  name={localStorage.getItem('userName')}></UserAvatar>
              </div>
            </a>
          </div>
        </Popover>
      </div>
    </div>
  )
}

export default Header
